'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useCallback, useMemo, useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import UIButton from 'UIComponents/button/UIButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import MobileFiltersPanel from './MobileFiltersPanel';
import StorefrontFilters from '../../../../records/StorefrontFilters';

const MobileFilterPanelNavigator = ({
  filters,
  onUpdateFilters,
  searchTerm,
  trackInteraction
}) => {
  const [panelOpen, setPanelOpen] = useState(false);
  useEffect(() => {
    if (panelOpen) {
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.body.style.overflow = 'visible';
    };
  }, [panelOpen]);
  const onPanelClose = useCallback(() => {
    setPanelOpen(false);
  }, [setPanelOpen]);
  const onPanelOpen = useCallback(() => {
    setPanelOpen(true);
  }, [setPanelOpen]);
  const renderedPanel = useMemo(() => {
    return /*#__PURE__*/_jsx(MobileFiltersPanel, {
      filters: filters,
      onUpdateFilters: onUpdateFilters,
      onPanelClose: onPanelClose,
      open: panelOpen,
      searchTerm: searchTerm,
      trackInteraction: trackInteraction
    }, `${filters}`);
  }, [filters, onUpdateFilters, onPanelClose, panelOpen, searchTerm, trackInteraction]);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(UIButton, {
      onClick: onPanelOpen,
      size: "sm",
      style: {
        width: 'initial',
        textOverflow: 'inherit'
      },
      use: "tertiary-light",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "appMarketplace.storefront.filters.filter"
      })
    }), renderedPanel]
  });
};

MobileFilterPanelNavigator.propTypes = {
  filters: PropTypes.instanceOf(StorefrontFilters).isRequired,
  searchTerm: PropTypes.string.isRequired,
  onUpdateFilters: PropTypes.func.isRequired,
  trackInteraction: PropTypes.func.isRequired
};
export default MobileFilterPanelNavigator;